import { HttpClient } from '@angular/common/http';
import { IModuleTranslationOptions, ModuleTranslateLoader } from '@larscom/ngx-translate-module-loader';
import { TranslateLoader, TranslateModuleConfig } from '@ngx-translate/core';
import { from, of, tap } from 'rxjs';
import { baseTranslateUrl } from 'src/environments/environment';
export function moduleHttpLoaderFactory(http: HttpClient) {
	const options: IModuleTranslationOptions = {
		lowercaseNamespace: true,
		modules: [
			{ moduleName: 'register', baseTranslateUrl },
			{ moduleName: 'login', baseTranslateUrl },
		],
	};
	return new ModuleTranslateLoader(http, options);
}

export class CustomTranslator implements TranslateLoader {
	constructor(private http: HttpClient) {}
	getTranslation(lang: string) {
		// console.log('asd', lang);
		return this.http
			.get(`${baseTranslateUrl}/${lang}.json`)
			.pipe
			// tap((res) => console.log(res))
			();
	}
}

export const translationConfig: TranslateModuleConfig = {
	defaultLanguage: 'en',
	// loader: { provide: TranslateLoader, useClass: CustomTranslator, deps: [HttpClient] },
	loader: { provide: TranslateLoader, useFactory: moduleHttpLoaderFactory, deps: [HttpClient] },
};
